import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { useTranslation } from "react-i18next";
import PiSettingsTile from "../../components/PiSettingsTile";
import ProjectSettingsBody from "./ProjectSettingsBody";
import "./ProjectSettingsWorkspace.css";

export default function ProjectSettingsWorkspace() {
  const { t } = useTranslation();

  return (
    <div
      className="projectsettings-workspace"
      data-testid="project-settings-workspace"
    >
      <header className="projectsettings-workspace__header">
        <div className="projectsettings-workspace__title-icon">
          <TuneOutlinedIcon fontSize="inherit" />
        </div>
        <div className="projectsettings-workspace__title-copy">
          <div className="projectsettings-workspace__eyebrow">
            {t("project_settings.tab_label")}
          </div>
          <h1>{t("project_settings.title")}</h1>
        </div>
      </header>

      <main className="projectsettings-workspace__content">
        <PiSettingsTile
          title={t("project_settings.playback_section")}
          icon={PlayCircleOutlineOutlinedIcon}
          variant="divided"
          className="projectsettings-workspace__section"
          contentClassName="projectsettings-workspace__section-body"
        >
          <ProjectSettingsBody />
        </PiSettingsTile>
      </main>
    </div>
  );
}
